import axios from 'axios'

const request = async (query, params, isGeneral) => {
  let url = isGeneral
    ? process.env.GRAPHQL_API + 'general'
    : process.env.GRAPHQL_API
  const response = await axios({
    method: 'POST',
    url,
    data: { params, query }
  })

  return response
}

export default request



// WEBPACK FOOTER //
// ./src/queries/index.js